import * as React from 'react'
import './Select.scss'
import {useState} from 'react'
import joinClassNames from '../../../helpers/joinClassNames'

type Options = {
    label: string
    value: string
}

type Props = {
    label: string
    name: string
    isRequired: boolean
    options: Options[]
    initValue?: string
    onChange?: (newValue: string) => void
    wrapperClassName?: string
}

const Select = ({label, name, isRequired, options, initValue, onChange, wrapperClassName}: Props) => {
    const placeholder = isRequired ? `${label}*` : label
    const optionsItems = options.map((option, index) => (
        <option value={option.value} key={index}>
            {option.label}
        </option>
    ))
    const [selected, setSelected] = useState(initValue || '')

    const handleChange = (e) => {
        const value = e.target.value
        setSelected(value)
        onChange?.(value)
    }

    return (
        <div className={joinClassNames('field', wrapperClassName || '')}>
            <div className="control has-margin-auto">
                <div className="select">
                    <select
                        name={name}
                        aria-label={name}
                        className={`input select-input ${selected === '' ? 'placeholder' : 'selected'}`}
                        required={isRequired}
                        onChange={handleChange}
                        value={selected}
                    >
                        <option className="placeholder" value={''} disabled hidden>
                            {placeholder}
                        </option>
                        {optionsItems}
                    </select>
                </div>
            </div>
        </div>
    )
}

export default Select
